module.exports = __webpack_public_path__ + "fonts/yubico@2x.9eaa61aa1dcd83d343ab523d26282ebe.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/yubico@2x.png
// module id = 785
// module chunks = 9